<template>
  <v-row class="ma-0">
    <v-col cols="12" class="pa-0" ref="headerSentinel">
      <v-row class="ma-0">
        <v-col cols="8">
          <h3>{{ $t('Configuração de indicadores') }}</h3>
          <span>
            {{
              $t(
                'Configure cada indicador escolhido e adicione sua análise crítica'
              )
            }}
          </span>
        </v-col>
        <v-col cols="4" class="d-flex justify-end align-center">
          <v-btn v-if="!isEditing" class="primary-button mr-2" depressed @click="$emit('saveDraft', chartInfos)">
            <v-icon left>mdi-content-save</v-icon>
            {{ $t('Salvar rascunho') }}
          </v-btn>
          <v-btn
            class="primary-button ma-0"
            depressed
            v-if="isEditing"
            @click="refreshData"
          >
            {{ $t('Atualizar dados dos indicadores para a data atual') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
    </v-col>

    <div
      v-if="headerFixed"
      class="configure-fixed-header"
      :style="{ width: fixedHeaderWidth }"
    >
      <v-row class="ma-0">
        <v-col cols="8">
          <h3>{{ $t('Configuração de indicadores') }}</h3>
          <span>
            {{
              $t(
                'Configure cada indicador escolhido e adicione sua análise crítica'
              )
            }}
          </span>
        </v-col>
        <v-col cols="4" class="d-flex justify-end align-center">
          <v-btn v-if="!isEditing" class="primary-button mr-2" depressed @click="$emit('saveDraft', chartInfos)">
            <v-icon left>mdi-content-save</v-icon>
            {{ $t('Salvar rascunho') }}
          </v-btn>
          <v-btn
            class="primary-button ma-0"
            depressed
            v-if="isEditing"
            @click="refreshData"
          >
            {{ $t('Atualizar dados dos indicadores para a data atual') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
    </div>

    <v-col cols="12" v-for="cat in categoriesWithSelection" :key="cat.id">
      <v-expansion-panels flat hover style="border-radius: 8px">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <strong>{{ $t(cat.nameKey) }}</strong>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-expansion-panels flat hover style="border-radius: 8px">
              <IndicatorConfigPanel
                v-for="ind in getSelectedForCategory(cat.id)"
                :key="ind.id"
                :indicator="ind"
                :isEditing="isEditing"
                :chartInfos="chartInfos"
                :selection="selection"
                :institution="institution"
                :unidades="unidades"
                :standardEquipments="standardEquipments"
                :refreshKey="refreshKey"
                @setInfos="saveChartInfo"
              />
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>

    <v-col cols="12">
      <v-card-actions class="justify-space-between">
        <v-btn text @click="$emit('back')">
          <v-icon>mdi-chevron-left</v-icon>
          {{ $t('Voltar') }}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn text @click="submit">
          {{ $t('Continuar') }}
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-col>
  </v-row>
</template>

<script>
import GeneralService from '../../../../../../services/GeneralService'
import IndicatorConfigPanel from './IndicatorConfigPanel.vue'
import {
  CATEGORIES,
  getVisibleIndicators,
  getSelectedIndicatorsForCategory,
} from '../../../indicators/indicatorRegistry'
import moment from 'moment'

export default {
  name: 'ConfigureCharts',

  components: {
    IndicatorConfigPanel,
  },

  props: {
    isEditing: Boolean,
    chartInfosProp: Array,
    selection: Array,
    unidades: Array,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    const defaultStart = moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD')
    const defaultEnd = moment().add(-1, 'month').endOf('month').format('YYYY-MM-DD')
    const base = this.chartInfosProp || this.selection.map((x) => ({ chart: x }))
    this.chartInfos = base.map((x) => ({
      ...x,
      startDate: x.startDate || defaultStart,
      endDate: x.endDate || defaultEnd,
    }))
    await this.getStandardEquipments()
  },

  data() {
    return {
      generalService: new GeneralService(),
      institution: {},
      standardEquipments: [],
      chartInfos: [],
      refreshKey: 0,
      headerFixed: false,
      fixedHeaderWidth: '100%',
    }
  },

  mounted() {
    this._scrollHandler = () => {
      const sentinel = this.$refs.headerSentinel
      if (!sentinel) return
      const rect = sentinel.getBoundingClientRect()
      this.headerFixed = rect.bottom < 64
      if (this.headerFixed) {
        this.fixedHeaderWidth = sentinel.offsetWidth + 'px'
      }
    }
    window.addEventListener('scroll', this._scrollHandler)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this._scrollHandler)
  },

  computed: {
    categoriesWithSelection() {
      return CATEGORIES.filter(
        (cat) =>
          getSelectedIndicatorsForCategory(
            cat.id,
            this.selection,
            this.institution
          ).length > 0
      )
    },
  },

  watch: {
    chartInfosProp(newValue) {
      if (newValue && newValue.length > 0) {
        this.chartInfos = newValue
        this.refreshKey++
      }
    },

    selection() {
      const defaultStart = moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD')
      const defaultEnd = moment().add(-1, 'month').endOf('month').format('YYYY-MM-DD')
      if (this.chartInfos && this.chartInfos.length > 0) {
        this.chartInfos = this.chartInfos.filter((x) =>
          this.selection.includes(x.chart)
        )

        this.chartInfos.push(
          ...this.selection
            .filter((x) => !this.chartInfos.map((x) => x.chart).includes(x))
            .map((x) => ({ chart: x, startDate: defaultStart, endDate: defaultEnd }))
        )
      } else {
        this.chartInfos = this.selection.map((x) => ({
          chart: x,
          startDate: defaultStart,
          endDate: defaultEnd,
        }))
      }
    },
  },

  methods: {
    refreshData() {
      this.$emit('refresh')
    },

    getSelectedForCategory(categoryId) {
      return getSelectedIndicatorsForCategory(
        categoryId,
        this.selection,
        this.institution
      )
    },

    async getStandardEquipments() {
      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institution.id
        )
    },

    saveChartInfo(value) {
      let info = this.chartInfos.find((x) => x.chart == value.chart)
      let infoIndex = this.chartInfos.indexOf(info)
      if (infoIndex != -1) {
        this.chartInfos[infoIndex] = value
      } else {
        this.chartInfos.push(value)
      }
    },

    submit() {
      const find = this.chartInfos.find((x) => !x.review)

      if (find) {
        this.$toast.warning(
          `O indicador "${find.chart}" ainda não possui análise crítica`
        )
        return
      }

      this.chartInfos = this.chartInfos.filter((x) =>
        this.selection.includes(x.chart)
      )

      this.$emit('next', this.chartInfos)
    },
  },
}
</script>

<style scoped>
.configure-fixed-header {
  position: fixed;
  top: 64px;
  z-index: 100;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  padding: 0 12px;
}
</style>
